import { render, staticRenderFns } from "./userItem.component.vue?vue&type=template&id=2d567463&scoped=true&"
import script from "./userItem.component.vue?vue&type=script&lang=js&"
export * from "./userItem.component.vue?vue&type=script&lang=js&"
import style0 from "./userItem.component.vue?vue&type=style&index=0&id=2d567463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d567463",
  null
  
)

export default component.exports